export enum AffinityType {
  STANDARD = 'standard',
  ASYMMETRIC = 'asymmetric'
}
